import type React from 'react'

interface CenterContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode
}

export default function CenterContainer({ children, className, ...props }: CenterContainerProps) {
  return (
    <div
      className={
        [
          'absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2',
          'w-full max-w-[960px]',
          'h-[60%] max-[425px]:h-[75%] max-[425px]:p-4',
          'flex items-center justify-center',
          'text-white',
          // glassmorphism base
          'bg-white/15 backdrop-blur-md border border-white/30 rounded-[2.5rem] shadow-[0_8px_32px_0_rgba(0,0,0,0.1)]',
          className,
        ]
          .filter(Boolean)
          .join(' ')
      }
      {...props}
    >
      <div className="text-center">{children}</div>
    </div>
  )
}
